// extracted by mini-css-extract-plugin
export default {"container":"Sort_container__EePqw","icon":"Sort_icon__GzSxJ"};